module.exports = __webpack_public_path__ + "img/co_bg1.e35a007e.png";